import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_TICKETS_API_URL || 'https://erp.intrare.app'
const API_KEY = process.env.VUE_APP_TICKETS_API_KEY || 'intrare_PpDmhOSqc8fgDcFFEPVfKIK6KH7PWo26lMd4C-VlI04'

const headers = () => {
  const result = { 'Content-Type': 'application/json' }
  if (API_KEY) result['X-API-Key'] = API_KEY
  return result
}

const normalizeResponse = response => {
  const payload = response && response.data
  if (payload && Object.prototype.hasOwnProperty.call(payload, 'success')) {
    return payload
  }
  return { success: true, data: payload }
}

export const ticketsService = {
  isConfigured: Boolean(API_KEY),

  async getAreas () {
    const response = await axios.get(`${API_BASE_URL}/api/areas`, { headers: headers() })
    return normalizeResponse(response)
  },

  async getTicketsByEmail (email, limit = 100) {
    const response = await axios.get(`${API_BASE_URL}/api/tickets`, {
      headers: headers(),
      params: { email, limit }
    })
    return normalizeResponse(response)
  },

  async getTicketById (id) {
    const response = await axios.get(`${API_BASE_URL}/api/ticket/${id}`, { headers: headers() })
    const normalized = normalizeResponse(response)
    if (Array.isArray(normalized.data)) normalized.data = normalized.data[0] || null
    return normalized
  },

  async createTicket (ticket) {
    const response = await axios.post(`${API_BASE_URL}/api/tickets`, ticket, { headers: headers() })
    return normalizeResponse(response)
  }
}

export default ticketsService
